import { formatUtcDateTime } from '../../common/utils/date.js'
import { useI18n } from '../../i18n/index.js'
import type { ValueRendererComponent } from '../types.js'
import { relativeDatesFactory } from '../valuePickers/DateValuePicker.js'

export const DateRenderer: ValueRendererComponent = ({ filter }) => {
  const intl = useI18n()
  const { value } = filter
  if (typeof value === 'string') {
    return <>{formatUtcDateTime(value, 'MMMM D, YYYY')}</>
  }

  if (typeof value === 'number') {
    const relativeDates = relativeDatesFactory(intl)
    const relativeDate = relativeDates.find(
      relativeDate => relativeDate.value === value,
    )

    if (relativeDate.text) {
      return <>{relativeDate.text}</>
    }
  }

  return null
}
